import { CollectionList, Form } from '@mairistem/composants';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import { validateMail, validatePhone } from '@/utils';
import RegieContactListItem from './RegieContactListItem';
import RegieContactListItemForm from './RegieContactListItemForm';

interface RegieContactListProps {
  telephone: string;
  mail: string;
  website: string;
  onChange: (e: any) => void;
  control?: React.ReactNode;
  form?: React.ReactNode;
}

const RegieContactList = (props: RegieContactListProps) => {
  const {
    telephone,
    website,
    mail,
    onChange,
    control = RegieContactListItem,
    form = RegieContactListItemForm,
  } = props;

  const items = React.useMemo(() => {
    if (telephone || website || mail) {
      return [
        {
          key: '1',
          telephone,
          website,
          mail,
        },
      ];
    }

    return [];
  }, [telephone, website, mail]);

  const handleChange = React.useCallback(
    (e, item) => {
      const errors: Record<string, string> = {};

      const phoneErrors = validatePhone(item.telephone);
      if (!_.isEmpty(item.telephone) && !_.isEmpty(phoneErrors)) {
        errors.telephone = _.head(phoneErrors).message;
      }

      const mailErrors = validateMail(item.mail);
      if (!_.isEmpty(item.mail) && !_.isEmpty(mailErrors)) {
        errors.mail = _.head(mailErrors).message;
      }

      if (_.isEmpty(errors)) {
        onChange({
          ..._.omit(item, 'key'),
        });

        return null;
      }

      return errors;
    },
    [onChange],
  );

  return (
    <Form.Group width={16}>
      <Form.Field width={16}>
        <label>Informations de contact</label>
        <CollectionList
          limit={1}
          formTitle="Informations de contact"
          // @ts-expect-error
          items={items}
          onItemCreate={handleChange}
          onItemUpdate={handleChange}
          itemControl={control as ReactNode}
          itemForm={form as ReactNode}
          modal={{ size: 'mini' }}
          style={{ margin: 0 }}
        />
      </Form.Field>
    </Form.Group>
  );
};

export default RegieContactList;
